import { useEffect, type ReactNode } from "react";
import { getDefaultStore } from "jotai";
import { useAuthState, uiLocaleAtom } from "@tubo/store";
import { UiI18nProvider } from "@tubo/ui/i18n";
import { isUiLocale } from "@tubo/api-models/business/common/ui-locale";

export function UiLocaleProvider({ children }: { children: ReactNode }) {
  const { user, uiLocale } = useAuthState();
  useEffect(() => {
    document.documentElement.lang = uiLocale;
    const storageKey = user?.user?.id ? `ui-locale:${user.user.id}` : "ui-locale:guest";
    const onStorage = (event: StorageEvent) => {
      if (event.key !== storageKey || !event.newValue) return;
      try {
        const locale: unknown = JSON.parse(event.newValue);
        if (isUiLocale(locale)) getDefaultStore().set(uiLocaleAtom, locale);
      } catch {
        // Ignore malformed values written by another browser context.
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [uiLocale, user?.user?.id]);
  return <UiI18nProvider locale={uiLocale} documentTitleKey="common:appTitle">{children}</UiI18nProvider>;
}
